import { render, staticRenderFns } from "./OfflinePolicySections.vue?vue&type=template&id=a153b9c8&scoped=true"
import script from "./OfflinePolicySections.vue?vue&type=script&lang=js"
export * from "./OfflinePolicySections.vue?vue&type=script&lang=js"
import style0 from "./OfflinePolicySections.vue?vue&type=style&index=0&id=a153b9c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a153b9c8",
  null
  
)

export default component.exports